import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import CustomModal from '../CustomModal';

const RemoveNetworkModal = ({ modal, onHide, network, onRemoveNetwork }) => {
  const removeAndClose = () => {
    onHide(false);
    onRemoveNetwork(network);
  };

  return (
    <CustomModal modal={modal} onHide={onHide} size="md">
      <CustomModal.Header onHide={onHide}>
        Remove a Wi-Fi Network
      </CustomModal.Header>
      <CustomModal.Body>
        <div className="text-center">Are you sure you want to remove</div>
        <h4 className="text-center my-2">{network.ssid ?? 'this network'}</h4>
        <div className="text-center">from your Preferred Networks?</div>
      </CustomModal.Body>
      <CustomModal.Footer>
        <Button
          variant="link"
          className="text-capitalize"
          onClick={() => onHide(false)}
        >
          Cancel
        </Button>
        <Button type="submit" className="mx-4" onClick={removeAndClose}>
          Remove Network
        </Button>
      </CustomModal.Footer>
    </CustomModal>
  );
};

RemoveNetworkModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  network: PropTypes.shape({
    ssid: PropTypes.string.isRequired,
  }).isRequired,
  onRemoveNetwork: PropTypes.func.isRequired,
};

export default RemoveNetworkModal;
